export const teeMarkerColor = (siteSetupData, teeMarkerSeetingId) => {
    let rgb = "#fff";
    let found = siteSetupData?.TeeMarkerSettings?.find(item => item.Id === teeMarkerSeetingId)
    if (found) {
        let color = found.ColorRGB >>> 0;
        if (color) rgb = "#" + color.toString(16).substr(-6);
    }
    return rgb;
};

export function getTextColorBasedOnRGB(siteSetupData, teeMarkerSeetingId) {
    let rgb = "000000";
    let found = siteSetupData?.TeeMarkerSettings?.find(item => item.Id === teeMarkerSeetingId)
    if (found) {
        let color = found.ColorRGB >>> 0;
        if (color) rgb = color.toString(16).substr(-6);
    }

    if (typeof rgb === "string") {
        //these methods borrowed from JSColor
        var r = parseInt(rgb.substr(0, 2), 16) / 255;
        var g = parseInt(rgb.substr(2, 2), 16) / 255;
        var b = parseInt(rgb.substr(4, 2), 16) / 255;
        return (0.213 * r +
            0.715 * g +
            0.072 * b < 0.5) ? '#FFFFFF' : '#000000';
    }
    return '#FFFFFF'; //fallback
}